import { schema } from "normalizr";

export const classObject = new schema.Entity(
  "classes",
  {},
  { idAttribute: "class_id" }
);
